// extracted by mini-css-extract-plugin
module.exports = {"container":"_82e3db2ea0--container--aRsey","tablet":"_82e3db2ea0--tablet--VR_t6","phone":"_82e3db2ea0--phone--o9NlB","features":"_82e3db2ea0--features--s_jHB"};